import { callApi, HTTPMethods } from '@/utils/api';
import KeycloakService from './keycloakService';
import { getApiUrl } from '@/utils/url';
import { UseClientStore } from '@/store/clientStore';

export default {
  async getClientInfoFromRcu() {
    try {
      await KeycloakService.CallUpdate();
      const config = {
        'Content-Type': 'application/json',
      };
      const clientsStore = UseClientStore();

      await callApi({
        path: `${getApiUrl()}/clients`,
        method: HTTPMethods.GET,
        options: config,
        successCallback: (result: any) => {
          clientsStore.setClientInfo(result);
        },
        errorMessage: '',
      });
    } catch (error) {
      //not critical
      console.log(error);
    }
  },
};
